<p-dialog [(visible)]="visible" 
          [modal]="true" 
          [header]="editingItem ? 'Edit Education' : 'Add Education'" 
          [style]="{width: '94vw', maxWidth: '520px'}"
          [draggable]="false"
          [resizable]="false"
          styleClass="education-modal"
          appendTo="body"
          (onHide)="closeDialog()">
    
    <form *ngIf="tempEducationForm" [formGroup]="tempEducationForm" class="space-y-4 pt-4 pb-2 px-1">
        <!-- School Name -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">School/University Name <span class="text-red-500">*</span></label>
            <input type="text" 
                   formControlName="university_name" 
                   class="block w-full text-sm border border-gray-300 rounded-lg p-3 outline-none focus:border-primary transition-all placeholder:text-gray-400" 
                   placeholder="Ex: Northwestern University">
            <div *ngIf="tempEducationForm.get('university_name')?.invalid && (tempEducationForm.get('university_name')?.dirty || tempEducationForm.get('university_name')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                School name is required.
            </div>
        </div>

        <!-- University Address -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">School/University Location <span class="text-red-500">*</span></label>
            <input type="text" 
                   formControlName="university_address" 
                   class="block w-full text-sm border border-gray-300 rounded-lg p-3 outline-none focus:border-primary transition-all placeholder:text-gray-400" 
                   placeholder="Ex: Evanston, IL">
            <div *ngIf="tempEducationForm.get('university_address')?.invalid && (tempEducationForm.get('university_address')?.dirty || tempEducationForm.get('university_address')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                Location is required.
            </div>
        </div>

        <!-- Degree -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Degree <span class="text-red-500">*</span></label>
            <div class="w-full border_dropdown">
                <p-dropdown styleClass="w-full text-sm py-0.5" 
                            [options]="constants?.digreeListObjArray" 
                            formControlName="degree_type" 
                            optionLabel="name" 
                            optionValue="value" 
                            placeholder="Ex: Bachelors"
                            appendTo="body" />
            </div>
        </div>

        <!-- Field of Study -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Field of Study <span class="text-red-500">*</span></label>
            <input type="text" 
                   formControlName="specialization" 
                   class="block w-full text-sm border border-gray-300 rounded-lg p-3 outline-none focus:border-primary transition-all placeholder:text-gray-400" 
                   placeholder="Ex: Computer Science">
            <div *ngIf="tempEducationForm.get('specialization')?.invalid && (tempEducationForm.get('specialization')?.dirty || tempEducationForm.get('specialization')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                Field of Study is required.
            </div>
        </div>

        <!-- Dates Attended -->
        <div class="space-y-1.5">
            <label class="block text-[#1A1A1A] text-sm lg:text-15 font-medium">Dates Attended <span class="text-red-500">*</span></label>
            <div class="flex gap-4">
                <div class="flex-1 border_dropdown">
                    <p-dropdown styleClass="w-full text-sm py-0.5" [options]="yearList" formControlName="start_year" optionLabel="name" optionValue="value" placeholder="From" appendTo="body" />
                </div>
                <div class="flex-1 border_dropdown">
                    <p-dropdown styleClass="w-full text-sm py-0.5" [options]="yearList" formControlName="end_year" optionLabel="name" optionValue="value" placeholder="To" appendTo="body" />
                </div>
            </div>
            <div *ngIf="tempEducationForm.hasError('yearRange') && (tempEducationForm.get('end_year')?.dirty || tempEducationForm.get('end_year')?.touched)" 
                 class="text-red-500 text-[11px] mt-0.5 ml-1">
                End year cannot be less than start year.
            </div>
        </div>

        <!-- Document Upload -->
        <div class="space-y-1.5 pt-1">
            <div class="flex items-center gap-1.5">
                <label class="block text-[#1A1A1A] text-sm font-medium">Upload Diploma</label>
                <span [pTooltip]="'Get A “Diploma Verified” Badge: Upload Your Diploma To Boost Your Credibility! Our Team Will Review It And Add The Badge To Your Profile. JPG Or PNG Format; Maximum Size Of 20MB.'" 
                      tooltipPosition="top" 
                      appendTo="body"
                      tooltipStyleClass="education-tooltip"
                      class="flex items-center cursor-help">
                    <svg xmlns="http://www.w3.org/2000/svg" 
                         class="h-4 w-4 text-primary" 
                         fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </span>
            </div>
            
            <input id="modal_document_upload" type="file" class="hidden" (change)="updateEducationDocument($event)">
            
            <div *ngIf="!tempEducationForm.get('document')?.value" 
                 class="border border-dashed border-gray-200 rounded-lg p-3 bg-gray-50/30 flex items-center justify-between transition-colors hover:bg-gray-50">
                <p class="text-[11px] text-gray-500">Max 20MB (JPG, PNG)</p>
                <label for="modal_document_upload" 
                       class="cursor-pointer px-6 py-1.5 bg-primary text-white text-xs rounded-lg hover:bg-blue-600 transition-colors shadow-sm font-bold">
                    Upload
                </label>
            </div>

            <!-- Preview -->
            <div *ngIf="tempEducationForm.get('document')?.value" 
                 class="flex items-center gap-3 border border-gray-200 rounded-lg p-2.5 bg-white">
                <div class="w-10 h-10 rounded overflow-hidden shadow-sm border border-gray-100">
                    <p-image [src]="tempEducationForm.get('document')?.value?.startsWith('http') ? tempEducationForm.get('document')?.value : (tempEducationForm.get('document')?.value?.startsWith('data:') ? tempEducationForm.get('document')?.value : constants?.baseImageUrl + tempEducationForm.get('document')?.value)" 
                             alt="Diploma" 
                             styleClass="w-full h-full object-cover" 
                             [preview]="true"/>
                </div>
                <div class="flex-1">
                    <p class="text-[11px] text-gray-600 truncate font-medium">Supporting Document Attached</p>
                </div>
                <label for="modal_document_upload" class="text-[#2ECC71] text-xs font-bold cursor-pointer hover:underline">Change</label>
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="flex items-center justify-end gap-6 pt-5 pb-1">
            <button type="button" 
                    (click)="closeDialog()" 
                    class="text-gray-500 hover:text-gray-800 transition-colors font-medium text-15">
                Cancel
            </button>
            <button type="button" 
                    (click)="saveEducationItem()" 
                    class="px-8 py-2.5 bg-primary hover:bg-blue-600 text-white rounded-lg transition-all font-bold shadow-sm text-sm lg:text-15"
                    [disabled]="isBtnLoading">
                <span class="inline-block" *ngIf="isBtnLoading">
                    <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-inherit" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"> 
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle> 
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path> 
                    </svg>
                </span>
                Save
            </button>
        </div>
    </form>
</p-dialog>
